<div class="container-input-file">
  <mat-label class="container-input-file__label">{{ 'INPUTS.' + placeholder | translate }}</mat-label>
  
  <mat-form-field appearance="outline" class="full-width" (click)="fileInput.click()">
    <input matInput readonly [value]="fileName" placeholder="{{ 'INPUTS.Sin_Archivo' | translate }}" [disabled]="disabled">
    
    <button mat-icon-button matSuffix type="button" color="primary" class="container-input-file__button">
      <atom-icon class="container-input-file__icon" [iconClass]="'fa-solid fa-paperclip'" [iconColor]="'#16726b'" />
    </button>

    <input #fileInput type="file" [multiple]="multiple" (change)="onInput($event)" [accept]="accept" [disabled]="disabled" hidden>
  </mat-form-field>
</div>